export class Color {
  static setAlpha(color: string, percentage: number) {
    if (!color.startsWith('#')) color = '#' + color;

    percentage = Math.max(0, Math.min(percentage, 1));
    const decimalValue = Math.round(255 * percentage);
    const hexValue = decimalValue.toString(16);

    const missingAlpha = color.length === 7;

    if (missingAlpha && percentage === 1) return color;

    if (missingAlpha) {
      return color + hexValue;
    } else if (color.length === 9) {
      return color.slice(0, 7) + hexValue;
    } else {
      throw new Error(`${color} is not a hex color code`);
    }
  }
}
